module.exports = __webpack_public_path__ + "media/src/ui/images/iconMobile-35a4569e15646873ccb6460ac5f7245b.svg";